<app-ehe-layout id="app-forgot-password-page" [footer]="false">
	<div class="forgot-section-wrapper general-wrapper">
		<section class="container">
			<div class="row justify-content-md-center">
				<div class="col-md-8 content-box">
					<div class="auth-content-wrapper">
						<app-forgot-password></app-forgot-password>
					</div>
				</div>
			</div>
		</section>
	</div>
</app-ehe-layout>
